import './WasteTypeSiteAdditionalBlock.scss';

interface WasteTypeSiteAdditionalBlockProps {
  graphData: any[];
  typeArray: any[];
};

const WasteTypeSiteAdditionalBlock = (props: WasteTypeSiteAdditionalBlockProps) => {
  const siteHeaders = props.graphData.map(site => site.name);
  const displayedTableData = props.typeArray.map(type => {
    const valueArr = props.graphData.map(site => site[type.label]);
    return [
      type.color,
      type.label,
      ...valueArr
    ];
  });
  return (
    <div className='split-container-site-additional'>
      <div className='table'>
        <table>
          <tr>
            <th style={{ width: '1%', backgroundColor: 'transparent', border: 'transparent' }}></th>
            <th style={{ width: '32%' }}>Customer Site</th>
            {siteHeaders.map((header, idx) =>
              <th key={'wt-site-header-' + idx} style={{ width: (67 / (siteHeaders.length + 1)) + '%' }}>{header}</th>
            )}
          </tr>
          {displayedTableData.map((wt, idx) =>
            <tr key={'wt-period-export-' + idx}>
              <td style={{ width: '1%', border: 'transparent' }}>
                <div className='color-circle' style={{ backgroundColor: wt[0] }}></div>
              </td>
              <td style={{ width: '32%' }}>{wt[1]}</td>
              {siteHeaders.map((_, idx) =>
                <td key={'wt-site-content-' + idx} style={{ width: (67 / (siteHeaders.length + 1)) + '%' }}>{wt[idx + 2]}</td>
              )}
            </tr>
          )}
        </table>
      </div>
    </div>
  );
};

export default WasteTypeSiteAdditionalBlock;